import { getAuth } from 'firebase/auth'
import { firebaseApp } from './firebase'

export const firebaseAuthFunc =  getAuth(firebaseApp)
